import BaseEvent from "ol/events/Event";
import { CommonEvents } from "./CommonEvents";

export default class InfoMessageEvent extends BaseEvent {
    message: string
    colour: string|undefined
    constructor(message: string, colour?: string) {
        super(CommonEvents.InfoMessage)
        this.message = message
        this.colour = colour
    }
}